<template>
  <div class="home">
    <Loader @done="closeLoader" v-if="showLoader"></Loader>

    <div class="container">
      <h1 class="logo">
        <img src="@/assets/images/logo.png"/>
      </h1>

      <p class="text">
        neurometronomy is the project of artist <a href="https://www.d-ovydas.com/" target="_blank">Dovydas
        Laurinaitis</a> (hi!) that investigates
        <span class="light-blue-bg">humans’ relationship to time</span> through a
        <span class="light-blue-bg">neurodivergent, queer and anti-capitalist</span> lens, specifically focusing on
        individuals with ADHD.
      </p>

      <div class="columns">
        <p class="column">
          ADHD is increasingly being understood as a time-related ‘disorder’ by psychologists and neurological research
          demonstrates that <span class="light-blue-bg">individuals with ADHD process time differently.</span>
        </p>
        <p class="column">
          A hypothesis within evolutionary psychology (hunter vs farmer) posits that individuals with ADHD are the
          <span class="light-blue-bg">descendants of hunters</span>—for who these ‘deficiencies’ were huge
          advantages—that found themselves societally displaced at the advent of the
          <span class="light-blue-bg">agricultural revolution</span>, unsuited to the
          <span class="light-blue-bg">stationary farmer lifestyle.</span>
        </p>
        <p class="column">
          Existing within societies that have a <span class="light-blue-bg">rigid, linear idea of time</span> (standard
          time) often generates various <span class="light-blue-bg">negative feelings</span> as we feel deficient since
          our ‘personal time-zones’ are often very <span class="light-blue-bg">misaligned with standard time.</span>
        </p>
      </div>

      <a target="_blank" href="https://docs.google.com/document/d/14AEOXDEUj5uLIb9Ka_6VbeDZ6CIAvVvO6PHa2KfGQo4" class="doc-link">
        an appropriately disorganised research doc that goes further into detail about the research
      </a>

      <p class="text">
        Over the last month, I’ve <span class="light-blue-bg">hosted two artists</span> in digital
        residencies/<span class="light-blue-bg">artistic dialogues</span> on their time-related practices.
        <br>
        <br>
        You can explore our research and artistic outcomes below.
      </p>

      <div class="buttons">
        <router-link class="button" to="/marilena">dialogue with Marilena</router-link>
        <router-link class="button" to="/kit">dialogue with Kit</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Loader from '@/components/Loader.vue'

export default {
  name: 'HomeView',
  components: {
    Loader
  },
  data() {
    return {
      showLoader: false,
    }
  },
  methods: {
    closeLoader() {
      this.showLoader = false;
    }
  },
  beforeMount() {
    if (!sessionStorage.getItem('visited')) {
      this.showLoader = true;
      sessionStorage.setItem('visited', 1);
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/vars.scss";

.home {
  padding: 60px 0;
  background: $background;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 100vh;
  height: 100%;

  .container {
    min-height: calc(100vh - 120px);
  }

  .logo {
    display: block;
    width: 100%;
    max-width: 1080px;
    height: auto;

    @include mobile {
      margin-bottom: 30px;
    }
  }


  .text {
    max-width: 750px;
  }

  .columns {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;

    @include mobile {
      flex-direction: column;
      margin: 30px 0;
    }

    .column {
      max-width: 370px;

      @include mobile {
        margin-bottom: 30px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .doc-link {
    max-width: 350px;
    display: block;
    @include mobile {
      margin-bottom: 30px;
    }
  }

  .buttons {
    max-width: 750px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;

    @include mobile {
      margin-top: 30px;
      flex-direction: column;

      .button:first-child {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
